import {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {Translate} from 'react-redux-i18n';
import {parse} from 'query-string';
import styles from './UserUpdateEmailView.style';
import userService from '../../services/user/UserService';
import authenticationService from '../../services/authentication/AuthenticationService';

export class UserUpdateEmailView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false
    };
  }

  componentDidMount() {
    if (!parse(this.props.location.search).token) {
      this.setState({error: true});
      return;
    }

    userService.updateEmail(parse(this.props.location.search).token)
      .then(() => {
        authenticationService.logout();
      }).catch(() => {
        this.setState({error: true});
      });
  }

  render() {
    return (
      <div style={styles.mainContainer}>
        {!this.state.error && <span className="loading-overlay"/>}
        {this.state.error && <Translate value="error.generic"/>}
      </div>
    );
  }
}

UserUpdateEmailView.propTypes = {
  location: PropTypes.object.isRequired
};

export default withRouter(UserUpdateEmailView);
